/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BookingIdRemarkRuleOrderValue {
    BrandAndMarket = 'BrandAndMarket',
    Description = 'Description'
}

export function BookingIdRemarkRuleOrderValueFromJSON(json: any): BookingIdRemarkRuleOrderValue {
    return BookingIdRemarkRuleOrderValueFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleOrderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleOrderValue {
    return json as BookingIdRemarkRuleOrderValue;
}

export function BookingIdRemarkRuleOrderValueToJSON(value?: BookingIdRemarkRuleOrderValue | null): any {
    return value as any;
}

